export const gettingStartedTourSteps = [
    {
        target: "[data-tour='sidebar']",
        content: "Everything you need is right here. Use the sidebar to move between your modules — from Growth Engine to UrStudio to Artist Manager and beyond.",
        placement: "right",
        title: "Sidebar Navigation"
    },
    {
        target: "[data-tour='sidebar-logo']",
        content: "Wherever you are on the platform, clicking the UpNComer logo brings you back home.",
        placement: "right",
        title: "Logo"
    },
    {
        target: "[data-tour='sidebar-menu']",
        content: "These are your tools. Each one is built to handle a different part of your career — pick whichever one you need and get to work.",
        placement: "right",
        title: "Roles Menu"
    },
    {
        target: "[data-tour='distribution-button']",
        content: "Ready to get your music out there? Hit this button to distribute your releases and manage your distribution account.",
        placement: "right",
        title: "Distribution Button"
    },
    {
        target: "[data-tour='ai-credits-progress']",
        content: "This tracks your AI credits. Every time you use an AI-powered feature across the platform, credits are used here. Keep an eye on it so you're never caught short.",
        placement: "right",
        title: "AI Credits Progress"
    },
    {
        target: "[data-tour='pro-button']",
        content: "You're on PRO. This is where you manage your plan, explore what's included, and make sure you're getting everything UpNComer has to offer.",
        placement: "right",
        title: "PRO Button"
    },
    {
        target: "[data-tour='header']",
        content: "The header keeps your most important tools within reach — search the platform, get support, and manage your notifications all from here.",
        placement: "bottom",
        title: "App Header"
    },
    {
        target: "[data-tour='header-navigation']",
        content: "Use these to jump to your Dashboard or reach our Support team directly. If you ever get stuck, Support is one click away.",
        placement: "bottom",
        title: "Header Navigation"
    },
    {
        target: "[data-tour='header-profile']",
        content: "This is your account. Update your profile, manage your settings, and keep your artist information current.",
        placement: "left",
        title: "User Profile"
    }
];

export const dashboardTourSteps = [
    {
        target: "[data-tour='amplitude-ai-chat']",
        content: "This is Amplitude — your AI career assistant. Ask it anything about your music, your growth, or your next move. It's built specifically for independent artists.",
        placement: "bottom",
        title: "Amplitude AI Chat"
    },
    {
        target: "[data-tour='performance-section']",
        content: "Your numbers at a glance. Streams, fanbase, listeners, followers, and your best performing track — all updated in real time.",
        placement: "top",
        title: "Performance Section"
    },
    {
        target: "[data-tour='finance-section']",
        content: "Know exactly what your music is making. Track your earnings, log your expenses, and forecast your revenue — all in one place.",
        placement: "top",
        title: "Finance Section"
    },
    {
        target: "[data-tour='music-link']",
        content: "Create a single link that sends fans straight to your music on any platform. One link. Every store.",
        placement: "top",
        title: "Create Music Link"
    },
    {
        target: "[data-tour='build-campaign']",
        content: "Launch ads directly from UpNComer. Build targeted campaigns that put your music in front of the right people.",
        placement: "top",
        title: "Build Campaigns"
    },
    {
        target: "[data-tour='quick-actions']",
        content: "Your shortcuts. Create a campaign, plan your tasks, understand your listeners, build a music link, or estimate your revenue — one click from here.",
        placement: "left",
        title: "Quick Actions"
    },
    {
        target: "[data-tour='master-track']",
        content: "Get your music release-ready. Master your tracks professionally without the studio price tag.",
        placement: "top",
        title: "Master Track"
    },
    {
        target: "[data-tour='data-analyst']",
        content: "See exactly where your fans are in the world. Use this to target the right cities, plan tours, and focus your marketing where it actually matters.",
        placement: "top",
        title: "Geographic Data"
    },
    {
        target: "[data-tour='release-planner']",
        content: "Stop releasing music without a plan. Use the Release Planner to schedule your drops, build momentum, and time everything for maximum impact.",
        placement: "left",
        title: "Release Planner"
    }
];

export const amplitudeAISteps = [
    {
        target: "[data-tour='suggestions-panel']",
        content: "These are live insights pulled from across your entire platform. Amplitude is always watching your data and surfacing the things that actually matter — click any suggestion to dig deeper.",
        placement: "left",
        title: "Ampltude AI Suggestions"
    },
    {
        target: "[data-tour='chat-history']",
        content: "This is where you talk to Amplitude. Ask it anything — your next release strategy, why your streams dropped, how to grow in a specific market. It knows your data and it answers in plain English.",
        placement: "bottom",
        title: "Amplitude AI Chat"
    },
    {
        target: "[data-tour='chat-history-dropdown']",
        content: "Every conversation you've had with Amplitude lives here. Come back to any previous session, pick up where you left off, or track how your strategy has evolved.",
        placement: "right",
        title: "Amplitude AI Chat History"
    },
    {
        target: "[data-tour='chat-input']",
        content: "Type your question here and hit submit. The more specific you are, the sharper the answer. Try starting with what you're trying to figure out right now.",
        placement: "bottom",
        title: "Amplitude AI Chat Input"
    },
];

export const studioGoalsTourSteps = [
    {
        target: "[data-tour='studio-goal-mixing']",
        content: "Upload your track and let UrStudio balance it. The Mixing Engineer adjusts levels, enhances clarity and gives your music a professional sound — without needing a studio engineer.",
        placement: "top",
        title: "Mixing Engineer"
    },
    {
        target: "[data-tour='studio-goal-mastering']",
        content: "The final step before release. Mastering makes your track loud, clear and consistent across every platform — Spotify, Apple Music, SoundCloud, all of it.",
        placement: "top",
        title: "Mastering Engineer"
    },
    {
        target: "[data-tour='studio-goal-enhancer']",
        content: "Take an existing mix further. Enhance it with AI and split it into individual stems — vocals, drums, bass, instruments — so you have full creative control over every element.",
        placement: "top",
        title: "Mix Enhancer + Stem Processor"
    },
    {
        target: "[data-tour='studio-goal-analyst']",
        content: "Not sure what your mix is missing? Mix Analyst breaks it down for you — frequency balance, dynamics, loudness — and tells you exactly what needs work.",
        placement: "top",
        title: "Mix Analyst"
    },
    {
        target: "[data-tour='mixes-library']",
        content: "Every mix you've worked on lives here. Upload new tracks, pick up where you left off, and keep your entire project library organised in one place.",
        placement: "top",
        title: "Mixes Library"
    },
    {
        target: "[data-tour='masters-library']",
        content: "Your release-ready tracks live here. Once a track is mastered it moves into your Masters Library — ready to distribute whenever you are.",
        placement: "top",
        title: "Masters Library"
    }
];

export const masteringEngineerTourSteps = [
    {
        target: "[data-tour='upload-section']",
        content: "Drop your track here to get started. UrStudio accepts MP3, WAV and FLAC. Once uploaded, the AI analyses your audio and builds a custom mastering chain around your specific genre and tone.",
        placement: "top",
        title: "Upload Your Track"
    },
    {
        target: "[data-tour='settings-section']",
        content: "Tell UrStudio what kind of track this is. Select your genre, set your loudness preference, and choose your output sample rate. These settings make sure the master is built specifically for your sound.",
        placement: "top",
        title: "Configure Settings"
    },
    {
        target: "[data-tour='processing-section']",
        content: "Your track is being processed. The AI is analysing your audio, optimising the frequencies, and normalising the loudness. This usually takes just a few minutes.",
        placement: "bottom",
        title: "Processing Status"
    },
    {
        target: "[data-tour='preview-section']",
        content: "Your master is ready. Hit play and toggle between Original and Master to hear the difference. When you're happy with it, hit the button to get your release-ready file.",
        placement: "bottom",
        title: "Track Preview"
    },
    {
        target: "[data-tour='master-section']",
        content: "This is your finished master. Listen back one more time, compare it to the original, then download it in your preferred format. This is the file that goes to distribution.",
        placement: "bottom",
        title: "Final Master Track"
    },
    {
        target: "[data-tour='amplitude-ai-chat']",
        content: "Once your track is mastered, Amplitude can help you figure out what to do next. Ask it about release timing, platform strategy, or how to maximise your rollout.",
        placement: "top",
        title: "Amplitude AI Chat"
    },
    {
        target: "[data-tour='masters-library']",
        content: "Every mastered track you create lives here. Come back anytime to re-download, share, or pick up where you left off on a previous project.",
        placement: "top",
        title: "Masters Library"
    }
];

export const mixingEngineerTourSteps = [
    {
        target: "[data-tour='upload-section']",
        content: "Upload your stems here to get started. You can bring in anywhere from 2 to 32 individual tracks — vocals, drums, guitar, bass, whatever you've got. The more stems you upload, the more detailed and precise your mix will be.",
        placement: "top",
        title: "Upload Your Tracks"
    },
    {
        target: "[data-tour='settings-section']",
        content: "Set your genre so the AI knows how to approach your mix, and choose your output sample rate. These settings make sure the mix is calibrated to your sound from the start.",
        placement: "top",
        title: "Configure Settings"
    },
    {
        target: "[data-tour='multitrack-section']",
        content: "This is your mixing workspace. All your uploaded stems are laid out here. You can see every track, adjust panning and levels, and monitor everything before creating your mix preview.",
        placement: "bottom",
        title: "Multitrack Editor"
    },
    {
        target: "[data-tour='upload-music-art']",
        content: "Add your release artwork here. It gets attached to your project and keeps everything organised in one place so your mix and your visual identity live together.",
        placement: "left",
        title: "Music Art Upload"
    },
    {
        target: "[data-tour='genre-and-edit-project']",
        content: "Keep your projects organised. Update the genre if it's changed and give your project a clear name so you can find it easily in your library later.",
        placement: "left",
        title: "Genre and Project Name"
    },
    {
        target: "[data-tour='tabs']",
        content: "Switch between your Multitrack, Mixes and Masters tabs here. Your full project history across all three stages lives in these tabs.",
        placement: "top",
        title: "Multitrack Tabs"
    },
    {
        target: "[data-tour='tracks-list']",
        content: "Every stem you uploaded is listed here. Set the panning, adjust levels, and tag each track by instrument type. If a stem has background noise or unwanted audio, hit the Clean Brush icon to clean it up before mixing.",
        placement: "left",
        title: "Tracks List"
    },
    {
        target: "[data-tour='upload-more']",
        content: "Need to add more stems? Hit Upload Tracks to bring in additional files at any point. You can add up to 32 tracks total.",
        placement: "top",
        title: "Upload More Tracks"
    },
    {
        target: "[data-tour='create-preview']",
        content: "When you're ready, hit Create Preview to generate your mix. This gives you a full preview to listen back to before committing to the final file.",
        placement: "top",
        title: "Create Preview"
    },
    {
        target: "[data-tour='preview-section']",
        content: "Your mix preview is ready. Listen back carefully and make sure everything sounds right. When you're happy, hit the button to get your final release-ready mixed track.",
        placement: "top",
        title: "Preview Your Mix"
    },
    {
        target: "[data-tour='mixed-section']",
        content: "This is your finished mix. Download it in your preferred file format — this is the version you take to mastering or straight to distribution.",
        placement: "top",
        title: "Preview Your Final Mix"
    },
    {
        target: "[data-tour='amplitude-ai-chat']",
        content: "Use Amplitude to plan your next step. Ask it about release strategy, what to do with your mixed tracks, or how to approach your rollout after this session.",
        placement: "top",
        title: "Amplitude AI Chat"
    },
    {
        target: "[data-tour='mixes-library']",
        content: "Every mix you've created lives here. Download, share or send a track straight to mastering — all from one place.",
        placement: "top",
        title: "Mixes Library"
    }
];

export const mixEnhancerTourSteps = [
    {
        target: "[data-tour='upload-section']",
        content: "Upload your mix track here to get started. UrStudio accepts MP3, WAV and FLAC. Once uploaded the AI analyses your audio and prepares it for enhancement.",
        placement: "top",
        title: "Upload Your Tracks"
    },
    {
        target: "[data-tour='preview-section']",
        content: "Once your track is processed, listen to the enhanced preview here. Not quite right? Adjust your settings and regenerate until it sounds exactly how you want it.",
        placement: "top",
        title: "Preview Section"
    },
    {
        target: "[data-tour='genre-selection']",
        content: "Select the genre or style that best fits your track. This tells the AI how to approach the enhancement so the result actually sounds right for your music.",
        placement: "top",
        title: "Genre or Style Selection"
    },
    {
        target: "[data-tour='is-mastered']",
        content: "Tell UrStudio whether your track has already been mastered. This affects how the AI enhances it — a mastered track gets treated differently to a raw mix.",
        placement: "top",
        title: "Is your track mastered?"
    },
    {
        target: "[data-tour='enhancement-settings']",
        content: "Choose exactly what you want fixed. Toggle on Fix Clipping, Fix Loudness, Fix Stereo Width, Fix Dynamic Range Compression, or Fix Tonal Balance — use only what your track actually needs.",
        placement: "top",
        title: "Enhancement Options"
    },
    {
        target: "[data-tour='mastering-option']",
        content: "Want to take it one step further? Choose whether to master your enhanced mix at the same time. Select your loudness target — CD for physical releases, Streaming for digital platforms.",
        placement: "top",
        title: "Mastering Section"
    },
    {
        target: "[data-tour='stems']",
        content: "If you want even more control, choose to individually process your stems. This splits and enhances each element of your track separately for maximum precision.",
        placement: "top",
        title: "Stems Process"
    },
    {
        target: "[data-tour='preview-button']",
        content: "When you've set everything up, hit this button to generate your enhanced preview. Once it's ready you can listen back, make adjustments, and download your final enhanced mix.",
        placement: "top",
        title: "Preview Button"
    },
    {
        target: "[data-tour='amplitude-ai-chat']",
        content: "Use Amplitude to plan what comes next. Ask it about your release strategy, how to promote your enhanced track, or anything else you need to figure out before you drop.",
        placement: "top",
        title: "Amplitude AI Chat"
    },
    {
        target: "[data-tour='mixes-library']",
        content: "All your enhanced mixes live here. Download, share, or send any track straight to mastering — everything in one place.",
        placement: "top",
        title: "Mixes Library"
    },
    {
        target: "[data-tour='stems-library']",
        content: "Your individually processed stems are stored here. Download each one separately, share them, or use them in your next production session.",
        placement: "top",
        title: "Stems Split Library"
    },
];

export const mixAnalystTourSteps = [
    {
        target: "[data-tour='upload-section']",
        content: "Upload your mix here and let the AI do a full technical analysis. UrStudio accepts MP3, WAV and FLAC. This will generate a detailed Mix Report showing exactly what's working and what needs attention.",
        placement: "top",
        title: "Upload Your Tracks"
    },
    {
        target: "[data-tour='settings-section']",
        content: "Set your genre or style so the analysis is calibrated to your sound, and choose whether you also want a master track preview generated alongside your Mix Report. Then hit Next to start the analysis.",
        placement: "top",
        title: "Settings"
    },
    {
        target: "[data-tour='mix-report']",
        content: "Your Mix Report is ready. This is a full technical breakdown of your track — sample rate, bit depth, clipping, loudness, mono compatibility and more. Use this to understand exactly where your mix stands before release.",
        placement: "top",
        title: "Mix Report"
    },
    {
        target: "[data-tour='master-preview']",
        content: "This is a 30-second preview of what your track sounds like mastered. Toggle between Original and After to hear the difference, then hit Get Full Track when you're ready for the complete master.",
        placement: "top",
        title: "Master Preview"
    },
    {
        target: "[data-tour='adjust-settings']",
        content: "Not happy with the master preview? Hit Adjust to tweak the loudness or genre settings and regenerate. Keep refining until it sounds exactly right.",
        placement: "top",
        title: "Adjust Settings"
    },
    {
        target: "[data-tour='full-track']",
        content: "When your preview sounds right, hit Get Full Track to generate your complete master. This is the release-ready version of your track.",
        placement: "top",
        title: "Get Full Master Track"
    },
    {
        target: "[data-tour='tonal-profile']",
        content: "This chart shows the frequency balance of your track across Bass, Low-Mid, High-Mid and Highs. Anything flagged as Too High needs attention before you release.",
        placement: "top",
        title: "Tonal Profile"
    },
    {
        target: "[data-tour='suggested-changes']",
        content: "These are the AI's specific recommendations based on your Mix Report. Each suggestion comes with a practical tip on how to fix it. Work through these before your next mix session.",
        placement: "top",
        title: "Tonal Profile"
    },
    {
        target: "[data-tour='new-upload']",
        content: "Done with this track? Hit New Upload to run a Mix Report on another track. Use Mix Analyst regularly to keep your sound consistently release-ready.",
        placement: "top",
        title: "New Upload"
    },
    {
        target: "[data-tour='share']",
        content: "Share your Mix Report with your producer, mixing engineer, or anyone else working on your track. One link gives them the full technical breakdown.",
        placement: "top",
        title: "Share Report Link"
    },
    {
        target: "[data-tour='save']",
        content: "Save your Mix Report as a PDF to reference later. Keep it alongside your project files so you always have the technical analysis on hand when you go back into the mix.",
        placement: "top",
        title: "Save Report"
    },
    {
        target: "[data-tour='amplitude-ai-chat']",
        content: "Use Amplitude to make sense of your Mix Report. Ask it to summarise your results, explain any of the technical findings, or help you figure out exactly what to fix before your next session.",
        placement: "top",
        title: "Amplitude AI Chat"
    }
];

export const dataAnalystTourSteps = [
    {
        target: "[data-tour='music-performance']",
        content: "This is your music performance overview. See your streams, listeners, followers and best performing track across every platform — filter by time period to track how your numbers are moving.",
        placement: "bottom",
        title: "Music Performance"
    },
    {
        target: "[data-tour='social-performance']",
        content: "Your social media numbers live here alongside your music data. Filter by platform and time period to understand where your content is gaining traction and where you need to push harder.",
        placement: "top",
        title: "Social Media Performance"
    },
    {
        target: "[data-tour='milestones']",
        content: "Every significant moment in your music career is tracked here. Playlist adds, follower milestones, video views — these are the wins that show your career is moving forward.",
        placement: "top",
        title: "Milestones"
    },
    {
        target: "[data-tour='radio-play']",
        content: "Find out where in the world your music is being played on radio. Every station, every broadcast — tracked and listed here so you know exactly where your music is reaching people.",
        placement: "top",
        title: "Radio Play"
    },
    {
        target: "[data-tour='audience-data']",
        content: "Understand who your audience actually is. Top city, top country, growth market — use this to make smarter decisions about where to focus your marketing and touring energy.",
        placement: "top",
        title: "Demographic Data"
    },
    {
        target: "[data-tour='popularity-score']",
        content: "Your Popularity Score measures how your music is performing relative to other artists on the platform. Track it over time and use it as a signal for when your releases are resonating.",
        placement: "top",
        title: "Popularity Score"
    },
    {
        target: "[data-tour='amplitude-insights']",
        content: "Amplitude surfaces the most relevant actions for your career right now — based on your actual data. These shortcuts take you directly to where you need to act.",
        placement: "left",
        title: "Amplitude AI Insights"
    },
];

export const catalogTourSteps = [
    {
        target: "[data-tour='track-performance']",
        content: "Dig into how each individual track is performing. Filter by time period to see streams, listeners, reach and playlist adds — and understand which releases are driving your growth.",
        placement: "top",
        title: "Track Performance"
    },
    {
        target: "[data-tour='geo-data']",
        content: "See exactly where in the world your listeners are. Search by location, zoom into specific markets, and use this to identify where your fanbase is growing fastest.",
        placement: "top",
        title: "Listeners Geo Insights"
    },
    {
        target: "[data-tour='amplitude-insights']",
        content: "Based on your catalog data, Amplitude recommends your next moves — from creating a music link to growing a playlist to mastering your next track. These buttons take you straight there.",
        placement: "left",
        title: "Amplitude AI Insights"
    },
    {
        target: "[data-tour='amplitude-ai-chat']",
        content: "Ask Amplitude anything about your catalog performance. It can break down your numbers, compare tracks, identify patterns in your listener data, and tell you what to focus on next.",
        placement: "left",
        title: "Amplitude AI Chat"
    },
    {
        target: "[data-tour='audience-section']",
        content: "Your full audience breakdown is here — country, city, age, gender and growth market. Use this to understand exactly who is listening to your music and build content and campaigns that speak directly to them.",
        placement: "top",
        title: "Audience Geographic Data"
    },
];

export const milestonesTourSteps = [
    {
        target: "[data-tour='milestones']",
        content: "See every major achievement across your platforms in one place — new followers, video milestones, playlist adds and more. Filter by platform and time period to track your momentum and spot which releases created the biggest impact.",
        placement: "bottom",
        title: "Milestones"
    },
    {
        target: "[data-tour='playlists-charts']",
        content: "Every playlist placement and chart entry, across every platform, in one feed. Filter by time period and platform to see where your music is landing and identify which tracks are getting picked up most.",
        placement: "bottom",
        title: "Plylists + Charts"
    },
    {
        target: "[data-tour='tracks-performance']",
        content: "Go deeper on individual track performance — playlists, reach, milestones and your top playlist placement. Use this to understand which tracks are building the most traction across platforms.",
        placement: "left",
        title: "Tracks Performance"
    },
    {
        target: "[data-tour='amplitude-insights']",
        content: "Based on your milestones data, Amplitude surfaces your next moves — whether that's running a pre-save campaign, growing a playlist, or pushing a track that's already gaining traction. One tap to take action.",
        placement: "left",
        title: "Amplitude AI Insights"
    },
];

export const radioPlayTourSteps = [
    {
        target: "[data-tour='geo-data']",
        content: "See exactly which countries and regions your music is hitting on radio. Use the map to spot your strongest markets and identify new territories where your tracks are starting to break through.",
        placement: "top",
        title: "Geo Data"
    },
    {
        target: "[data-tour='radio-milestones']",
        content: "Every radio play logged — station name, location, date and track. Search by track to see which songs are getting the most airplay and where in the world they're resonating.",
        placement: "top",
        title: "Radio"
    },
    {
        target: "[data-tour='tracks-performance']",
        content: "Your full radio performance at a glance — total plays, stations reached, most played track and your top country. Filter by time period to track how your radio presence is growing.",
        placement: "top",
        title: "Tracks Performance on Radio"
    },
    {
        target: "[data-tour='amplitude-insights']",
        content: "Amplitude reads your radio data and recommends what to do with it — from running a pre-save campaign to pitching a trending track further. Your next move is already mapped out.",
        placement: "left",
        title: "Amplitude AI Insights"
    },
];

export const artistManagerTourSteps = [
    {
        target: "[data-tour='artist-performance']",
        content: "Your top-level artist performance at a glance — followers, cost-per-fan, best performing song, ad spend and impressions. Filter by time period to track how your overall growth is trending across music and social.",
        placement: "bottom",
        title: "Artist Performance"
    },
    {
        target: "[data-tour='financial-performance']",
        content: "See how your music is performing financially — revenue generated, ROI, total expenditure and streams plus views. Filter by time period to understand which periods drove the most return and where your money is actually going.",
        placement: "top",
        title: "Artist Financial Performance"
    },
    {
        target: "[data-tour='amplitude-ai-chat']",
        content: "Tell Amplitude what you're trying to achieve and it'll help you build the right campaign. Whether you're growing your fanbase, pushing a new release or testing a new market — describe your vision and let it map out the strategy.",
        placement: "top",
        title: "Amplitude AI Chat"
    },
    {
        target: "[data-tour='release-planner']",
        content: "This section let's you schedule or manage your future events, manage and create your project tasks, plan your future releases through schedule planner.",
        placement: "top",
        title: "Release Planner"
    },
    {
        target: "[data-tour='links-and-fan-hub']",
        content: "Everything fans land on when they find you, managed in one place. Create and manage your bio links, music links, pre-save links and tour links — and track how each one is converting.",
        placement: "top",
        title: "Links and Fan Hub"
    },
];

export const financeHubTourSteps = [
    {
        target: "[data-tour='calendar']",
        content: "Plan every release, event and project milestone in one calendar. Add your upcoming drops, map out your rollout timeline and keep everything on track in one place.",
        placement: "top",
        title: "Release Planner"
    },
    {
        target: "[data-tour='task-planner']",
        content: "Break your release plan down into individual tasks. Set the category, objective, KPI, timeline and notes for each one — so nothing falls through the cracks between now and release day.",
        placement: "top",
        title: "Task Planner"
    },
    {
        target: "[data-tour='amplitude-ai-chat']",
        content: "Ask Amplitude anything about your upcoming release or your financial performance. It can help you plan a rollout, interpret your numbers, or identify where to focus your energy next.",
        placement: "bottom",
        title: "Amplitude AI Chat"
    },
    {
        target: "[data-tour='forecast-engine']",
        content: "See what your music is projected to earn over the next month, where your break-even point sits, and which revenue category Amplitude recommends you focus on. Powered by your actual performance data.",
        placement: "top",
        title: "Forecast Engine"
    },
    {
        target: "[data-tour='revenue-estimator']",
        content: "Run your own revenue estimate by selecting a category and subcategory. Use this to model different income scenarios and understand where your biggest earning opportunities are.",
        placement: "top",
        title: "Revenue Estimator"
    },
    {
        target: "[data-tour='roi-calculator']",
        content: "Track your logged revenue against your logged expenses and see your ROI for any given month. Your highest-performing revenue category is surfaced automatically so you always know what's working.",
        placement: "top",
        title: "ROI Calculator"
    },
    {
        target: "[data-tour='log-revenue']",
        content: "Log every income source — streaming, publishing, merch and more. Your DSP and royalties estimates are pulled in automatically, and everything is tracked monthly so you can see exactly what you earned and where it came from.",
        placement: "top",
        title: "Log Revenue"
    },
    {
        target: "[data-tour='log-expenses']",
        content: "Log every expense — ad spend, UpNComer subscription, and anything else you're investing in your career. Tracked monthly alongside your revenue so you always know what your music career is actually costing you.",
        placement: "top",
        title: "Log Expenses"
    },
];

export const linkAndFanHubTourSteps = [
    {
        target: "#tour-info-card",
        title: "Links & Fan Hub",
        content: "Every link you need to run your music career — bio links, music links, tour links and pre-saves — built, managed and tracked in one place. This is where you own your audience.",
        placement: "bottom",
        // disableBeacon: true,
    },
    {
        target: "#tour-bio-link",
        title: "Bio Link",
        content: "Build a personalised page that puts everything fans need in one spot — your music, socials, tour dates and more. One link, your whole world.",
        placement: "bottom",
    },
    {
        target: "#tour-music-link",
        title: "Music Link",
        content: "Create a smart landing page for every release with buttons linking out to every streaming platform. One link to share everywhere, every time you drop.",
        placement: "bottom",
    },
    {
        target: "#tour-tour-link",
        title: "Tour Link",
        content: "Build a dedicated page for your upcoming shows. Share it anywhere and give fans everything they need to find you live.",
        placement: "bottom",
    },
    {
        target: "#tour-pre-save",
        title: "Pre Save",
        content: "Build pre-save momentum before your release lands. Fans save it on Spotify and Apple Music in one tap — so day one numbers start strong.",
        placement: "bottom",
    },
    {
        target: "#tour-message-fans",
        title: "Message Your Fans",
        content: "Send personalised messages directly to your fanbase. Use this to announce releases, share updates, or stay connected with the fans who've already opted in.",
        placement: "bottom",
    },
    {
        target: "#tour-tab-yourLinks",
        title: "Your Links",
        content: "Every link you've created lives here. Edit, view analytics or copy any link directly from this list.",
        placement: "bottom",
        // disableBeacon: true,
    },
    {
        target: "#tour-links-list",
        title: "Your Links Library",
        content: "Your full link library in one view. Click into any link to dig into its analytics, update settings or make changes.",
        placement: "bottom",
        // disableBeacon: true,
    },
    {
        target: "#tour-tab-dashboard",
        title: "Dashboard",
        content: "See how all your links are performing in one view — page views, streaming link clicks and overall activity over time. Switch between time ranges to track what's working.",
        placement: "bottom",
    },
    {
        target: "#tour-dashboard-activity",
        title: "Overall Activity",
        content: "Your total link performance at a glance. Use the time range filter to see how your audience engagement has trended across all your links.",
        placement: "bottom",
    },
    {
        target: "#tour-dashboard-chart",
        title: "Activity Chart",
        content: "Track page views and streaming link clicks over time. Switch between 7 days, 30 days, 12 months or all time to understand your traffic patterns.",
        placement: "bottom",
    },
    {
        target: "#tour-dashboard-stats",
        title: "Key Metrics",
        content: "Your three most important link numbers — page visits, streaming link clicks and clickthrough rate — always visible at the top of your dashboard.",
        placement: "bottom",
    },
    {
        target: "#tour-dashboard-top-grid",
        title: "Top Sites & Streaming Services",
        content: "See which links are driving the most clicks and which streaming platforms your fans are going to. Use this to understand where to focus your promotion.",
        placement: "bottom",
    },
    {
        target: "#tour-dashboard-sources",
        title: "Top Traffic Sources",
        content: "See exactly where your link traffic is coming from — whether that's Instagram, Facebook, direct visits or elsewhere. Use this to double down on what's driving fans to your music.",
        placement: "bottom",
    },
    {
        target: "#tour-dashboard-countries",
        title: "Top Countries",
        content: "See which countries your fans are clicking from. Use this alongside your audience geo data to understand where your most engaged markets are.",
        placement: "bottom",
    },
    {
        target: "#tour-tab-futureSave",
        title: "Future Save",
        content: "Your most powerful fan retention tool. Fans who opt in automatically save every future release you drop — set it up once and every new release starts with a built-in audience.",
        placement: "bottom",
    },
    {
        target: "#tour-future-links",
        title: "Future Save Setup",
        content: "Connect your Spotify, Apple Music, Tidal and other profiles here. Once set up, any fan who opts in will automatically save your future releases across every platform they use.",
        placement: "top",
    },
    {
        target: "#tour-future-links-support",
        title: "Future Save Help",
        content: "Not sure how to promote Future Save or answer fan questions about it? The support card has everything you need — FAQs, tips and best practices.",
        placement: "left",
    },
    {
        target: "#tour-tab-fanbase",
        title: "Fanbase",
        content: "Every fan who has interacted with your links is logged here — email, location, platform and date added. This is your owned audience. Use it.",
        placement: "bottom",
    },
    {
        target: "#tour-fanbase-table",
        title: "Fanbase Export",
        content: "View and export your full fan list as a CSV. Take your audience data wherever you need it — email campaigns, ad targeting, direct outreach.",
        placement: "top",
    },
    {
        target: "#tour-tab-fanEngagement",
        title: "Fan Engagement",
        content: "Full fan engagement tracking — open rates, click-throughs and message performance — is coming soon. Stay tuned.",
        placement: "bottom",
    },
];

export const bioLinkTourSteps = [
    {
        target: "[data-tour='profile-form']",
        content: "Set up your bio link here. Add your profile image, name, description and background — and customize everything to match your artist identity.",
        placement: "top",
        title: "Bio Link Builder"
    },
    {
        target: "[data-tour='fan-actions']",
        content: "Choose what fans can do directly from your bio link — add tour dates, merch, an official store, a direct link, newsletter, WhatsApp, and more. Toggle on only what's relevant to you right now.",
        placement: "top",
        title: "Fan Actions"
    },
    {
        target: "[data-tour='streaming-actions']",
        content: "Connect your streaming profiles so fans can play your music directly from your bio link. Add or update Spotify, Deezer, SoundCloud, Tidal and more.",
        placement: "top",
        title: "Streaming Platforms"
    },
    {
        target: "[data-tour='social-actions']",
        content: "Add your social profile links so fans can follow you across every platform. Toggle each one on and set the button text and URL.",
        placement: "top",
        title: "Social Platforms"
    },
    {
        target: "[data-tour='collect-fan-data']",
        content: "Turn your bio link into a list-building tool. Enable this to add an email collection field so fans can subscribe directly from your page.",
        placement: "top",
        title: "Fan Email Collection"
    },
    {
        target: "[data-tour='social-footer']",
        content: "Add a social footer to the bottom of your bio link so fans can find and follow you across every platform in one place.",
        placement: "top",
        title: "Social Footer"
    },
    {
        target: "[data-tour='publish']",
        content: "When you're happy with how it looks, hit Publish. Your bio link goes live instantly and you can come back to edit it any time.",
        placement: "bottom",
        title: "Publish Your Bio Link"
    },
    {
        target: "[data-tour='mobile-demo']",
        content: "Everything you change updates live on the mobile preview to the right. What you see is exactly what your fans will see.",
        placement: "left",
        title: "Live Mobile Preview"
    },
    {
        target: "[data-tour='reorder']",
        content: "Drag and drop to set the order your streaming and social platforms appear on your bio link. Put the ones that matter most to your fans first",
        placement: "left",
        title: "Platform Order"
    },
];

export const musicLinkTourSteps = [
    {
        target: "[data-tour='profile-form']",
        content: "Set up your music link here. Select the track, choose your layout, pick a background and customise the page to match the release.",
        placement: "top",
        title: "Music Link Builder"
    },
    {
        target: "[data-tour='streaming-platforms']",
        content: "Add your streaming platform links so fans can play the track wherever they listen. Connect Spotify, Apple Music, Tidal, SoundCloud and more.",
        placement: "top",
        title: "Streaming Platforms"
    },
    {
        target: "[data-tour='preview-song']",
        content: "Turn on the song preview to add a music player directly to your link page. Fans can hear a snippet before they click through to stream.",
        placement: "top",
        title: "Song Preview"
    },
    {
        target: "[data-tour='collect-fan-data']",
        content: "Turn your music link into a list-building tool. Enable email collection so fans can subscribe directly from the release page — every drop is a chance to grow your list.",
        placement: "top",
        title: "Fan Email Collection"
    },
    {
        target: "[data-tour='social-footer']",
        content: "Add a social footer so fans landing on your music link can follow you across platforms without having to go anywhere else.",
        placement: "top",
        title: "Social Footer"
    },
    {
        target: "[data-tour='publish']",
        content: "When the link is ready, hit Publish and share it everywhere. You can come back and update it any time.",
        placement: "bottom",
        title: "Publish Your Music Link"
    },
    {
        target: "[data-tour='mobile-demo']",
        content: "Every change you make updates live in the mobile preview. Check how your release page looks to fans before you publish.",
        placement: "left",
        title: "Live Mobile Preview"
    },
];

export const tourLinkSteps = [
    {
        target: "[data-tour='profile-form']",
        content: "Set up your tour link here. Add your tour image, title, description and background — everything fans need to find you live in one place.",
        placement: "top",
        title: "Tour Link Builder"
    },
    {
        target: "[data-tour='fan-actions']",
        content: "Choose what fans can do directly from your tour link. Toggle on ticketing platforms like SongKick and Ticketfly, merch, mailing list and more — keep it focused on what's relevant to the show.",
        placement: "top",
        title: "Fan Actions"
    },
    {
        target: "[data-tour='collect-fan-data']",
        content: "Turn your tour link into a list-building moment. Enable email collection so fans can subscribe directly from the page — every show is a chance to grow your audience.",
        placement: "top",
        title: "Fan Email Collection"
    },
    {
        target: "[data-tour='social-footer']",
        content: "Add a social footer so fans who land on your tour link can follow you across platforms without leaving the page.",
        placement: "top",
        title: "Social Footer"
    },
    {
        target: "[data-tour='publish']",
        content: "When you're ready, hit Publish and share the link anywhere you're promoting the show. You can come back to update dates, tickets and details any time.",
        placement: "bottom",
        title: "Publish Your Tour Link"
    },
    {
        target: "[data-tour='mobile-demo']",
        content: "Every change you make updates live in the mobile preview. Check exactly what fans see before you publish.",
        placement: "left",
        title: "Live Mobile Preview"
    },
    {
        target: "[data-tour='reorder']",
        content: "Drag and drop to set the order your platforms appear on your tour link. Put the most important ones first.",
        placement: "left",
        title: "Platform Order"
    },
];

export const preSaveTourSteps = [
    {
        target: "[data-tour='profile-form']",
        content: "Set up your pre-save page here. Add the release title, description, subtitle, artwork, layout and background — everything fans see when they land on your page before the drop.",
        placement: "top",
        title: "Pre-Save Page Builder"
    },
    {
        target: "[data-tour='page-layout']",
        content: "Choose your page layout — Modern, Advanced or Base. Pick whichever best fits the visual feel of your release.",
        placement: "top",
        title: "Page Layout"
    },
    {
        target: "[data-tour='collect-fan-data']",
        content: "Three tools to make every pre-save work harder. Enable fan email collection, auto-follow your streaming profiles, and turn on Future Saves so fans automatically save every future release you drop.",
        placement: "top",
        title: "Growth Tools"
    },
    {
        target: "[data-tour='release-links']",
        content: "Add your release URL, UPC or ISRC so fans can pre-save on the right platforms. You can add this after setting up the page if you don't have it yet.",
        placement: "top",
        title: "Release Links"
    },
    {
        target: "[data-tour='release-date']",
        content: "Set your release date and time so the pre-save automatically converts to a save the moment your music goes live. Set the timezone to make sure it's accurate globally.",
        placement: "top",
        title: "Release Date"
    },
    {
        target: "[data-tour='pre-save-message']",
        content: "Write the message fans see immediately after they pre-save. Use this to thank them, hype the release, or tell them what's coming next.",
        placement: "left",
        title: "Fan Confirmation Message"
    },
    {
        target: "[data-tour='custom-links']",
        content: "Select every platform you want fans to be able to pre-save on. Fans who pre-save will automatically follow your profile on platforms that support it.",
        placement: "left",
        title: "Streaming Platforms"
    },
    {
        target: "[data-tour='page-customization']",
        content: "Check everything before you publish — page customization, release settings, platforms and notification details all in one summary view.",
        placement: "left",
        title: "Pre-Save Review Details"
    },
    {
        target: "[data-tour='publish']",
        content: "When everything looks right, hit Publish. Your pre-save page goes live instantly. Come back any time to update details or swap platforms.",
        placement: "bottom",
        title: "Publish Your Pre-Save page"
    },
    {
        target: "[data-tour='mobile-demo']",
        content: "Every change updates live in the mobile preview so you can see exactly what fans will see before you publish.",
        placement: "left",
        title: "Live Mobile Preview"
    },
];

export const linkAnalyticsTourSteps = [
    {
        target: "[data-tour='range-selector']",
        content: "Use the time range dropdown to filter all your analytics — switch between last 7 days, 30 days, 12 months or all time to see how your link has performed over any period.",
        placement: "bottom",
        title: "Time Range Filter"
    },
    {
        target: "[data-tour='stats-grid']",
        content: "Your three most important numbers at the top — page views, clicks to streaming platforms and signups. These tell you how many people landed on your link, how many went to stream, and how many subscribed.",
        placement: "top",
        title: "Key Stats"
    },
    {
        target: "[data-tour='analytics-chart']",
        content: "Your link traffic visualised over time. Track page views and streaming clicks together to see when your link was performing strongest and what drove the spikes.",
        placement: "top",
        title: "Analytics Chart"
    },
    {
        target: "[data-tour='chart-toggles']",
        content: "Toggle page views and streaming clicks on and off to isolate the metric you want to focus on. Useful when one line is dominating and you need to read the other more clearly.",
        placement: "top",
        title: "Chart Filters"
    },
    {
        target: "[data-tour='tabs-header']",
        content: "Three tabs cover everything — Content Analytics for platform performance, Demographics for where your visitors are coming from, and Collected Data for your subscriber list.",
        placement: "top",
        title: "Analytics Tabs"
    },
    {
        target: "[data-tour='content-analytics-tab']",
        content: "See how your link is performing across every streaming platform you've connected — click counts and percentage share of total service clicks, all in one view.",
        placement: "top",
        title: "Content Analytics Tab"
    },
    {
        target: "[data-tour='streaming-platforms']",
        content: "A ranked breakdown of every platform on your link — Spotify, YouTube, Apple Music and more — showing exactly how many fans clicked through to each one.",
        placement: "top",
        title: "Streaming Platforms"
    },
    {
        target: "[data-tour='demographics-tab']",
        content: "See where in the world your link traffic is coming from — broken down by country and city. Use this to understand which markets are responding to your release.",
        placement: "top",
        title: "Demographics Tab"
    },
    {
        target: "[data-tour='top-countries']",
        content: "Your top five countries ranked by visits, with city-level detail underneath. Use this alongside your Data Analyst geo data to build a full picture of where your audience is strongest.",
        placement: "top",
        title: "Top Countries by Visits"
    },
    {
        target: "[data-tour='collected-data-tab']",
        content: "Everyone who subscribed through your link is logged here — name, email, country and date added. This is your owned audience from this specific release or page.",
        placement: "top",
        title: "Collected Data Tab"
    },
    {
        target: "[data-tour='audience-table']",
        content: "Your full subscriber table for this link. Export or use this data for direct outreach, email campaigns or ad targeting — these are fans who already showed up for this release.",
        placement: "top",
        title: "Fan Data Table"
    },
    {
        target: "[data-tour='mobile-demo']",
        content: "Every change updates live in the mobile preview so you can see exactly what fans will see.",
        placement: "left",
        title: "Live Mobile Preview"
    }
];

export const growthEngineTourSteps = [
    {
        target: "[data-tour='artist-statistics-performance']",
        content: "Your top-level growth stats at a glance — followers, cost-per-fan, best performing song, ad spend and impressions. Filter by time period to track how your campaigns are moving the needle.",
        placement: "bottom",
        title: "Artist Statistics"
    },
    {
        target: "[data-tour='amplitude-ai-chat']",
        content: "Tell Amplitude what you're trying to grow and it'll help you build the right campaign. Describe your goal and let it map out the strategy.",
        placement: "top",
        title: "Amplitude AI Chat"
    },
    {
        target: "[data-tour='meta-campaigns']",
        content: "View and manage all your Meta ad campaigns in one place. See what's live, what's been created and how each campaign is performing.",
        placement: "top",
        title: "Meta Campaigns"
    },
    {
        target: "[data-tour='tiktok-campaigns']",
        content: "Your TikTok ad campaigns will live here. This section is currently in development — check back soon.",
        placement: "top",
        title: "TikTok Campaigns"
    },
    {
        target: "[data-tour='youtube-campaigns']",
        content: "Your YouTube ad campaigns will live here. This section is currently in development — check back soon.",
        placement: "top",
        title: "YouTube Campaigns"
    },
    {
        target: "[data-tour='amplitude-insights']",
        content: "Based on your growth data, Amplitude surfaces your next moves — from running a pre-save campaign to creating a music link to finding new fans in your genre. One tap to take action.",
        placement: "left",
        title: "Amplitude AI Insights"
    },
];

export const growthEngineStepperSteps = [
    {
        target: "[data-tour='campaign-selector']",
        content: "Start here. Pick your goal and platform — everything else in the setup flow adapts to what you choose.",
        placement: "top",
        title: "Campaign Selector"
    },
    {
        target: "[data-tour='objective-1']",
        content: "Run ads that send people directly to your music on streaming platforms. Best for release pushes and growing play counts",
        placement: "top",
        title: "More Streams"
    },
    {
        target: "[data-tour='objective-2']",
        content: "Run ads aimed at growing your Spotify follower count — not just streams, but people who follow your artist profile.",
        placement: "top",
        title: "Spotify Growth"
    },
    {
        target: "[data-tour='objective-3']",
        content: "Run ads to grow your Instagram following. Good for building a fanbase around your artist brand, not just your music.",
        placement: "top",
        title: "Instagram Growth"
    },
    {
        target: "[data-tour='objective-4']",
        content: "Promote a specific Spotify playlist you own — drive saves and followers to grow it over time.",
        placement: "top",
        title: "Spotify Playlist Growth"
    },
    {
        target: "[data-tour='objective-5']",
        content: "Drive more views to your YouTube videos through paid ads. Great for pushing music videos and building your channel.",
        placement: "top",
        title: "YouTube Growth"
    },
    {
        target: "[data-tour='objective-6']",
        content: "Run ads to any URL — a website, a music link, a merch store, or anything else you want to drive traffic to.",
        placement: "top",
        title: "Promote Custom Link"
    },
    {
        target: "[data-tour='objective-7']",
        content: "Running a show? Run ads that drive ticket sales and awareness for your upcoming events.",
        placement: "top",
        title: "Promote an Event"
    },
    {
        target: "[data-tour='objective-8']",
        content: "Run ads to promote your merch store and drive sales directly.",
        placement: "top",
        title: "Sell your merch"
    },
    {
        target: "[data-tour='select-platform']",
        content: "Choose which platform to run your ads on and connect the ad account you want the campaign created under. More platforms coming soon.",
        placement: "top",
        title: "Platform & Account"
    },
    {
        target: "[data-tour='choose-release']",
        content: "Select the release you want to promote. You can choose any single, project, playlist and artist you want to promote.",
        placement: "top",
        title: "Choose your release"
    },
    {
        target: "[data-tour='budget-schedule']",
        content: "Set how much you want to spend and how long your campaign runs.",
        placement: "top",
        title: "Budget & Schedule"
    },
    {
        target: "[data-tour='set-budget']",
        content: "Drag the slider to set your total spend. Choose Lifetime Budget for a fixed total, or Daily Budget for a recurring daily cap. Minimum recommended is $100.",
        placement: "top",
        title: "Set Budget"
    },
    {
        target: "[data-tour='set-dates']",
        content: "Pick when your campaign starts and ends. End date is optional if you're on a daily budget.",
        placement: "top",
        title: "Campaign Dates"
    },
    {
        target: "[data-tour='set-times']",
        content: "Set the exact start and end times on your chosen launch and end dates.",
        placement: "top",
        title: "Campaign Times"
    },
    {
        target: "[data-tour='audience-targeting']",
        content: "Define who sees your ads. Set demographics, location, language, and interests to reach the right listeners",
        placement: "top",
        title: "Audience Targeting"
    },
    {
        target: "[data-tour='demographic-targeting']",
        content: "Set the age range and gender for your target audience.",
        placement: "top",
        title: "Demographic Targeting"
    },
    {
        target: "[data-tour='location-targeting']",
        content: "Choose where your ads run — Primary Music Markets, Global, or specific countries and cities. Some locations may require additional verification depending on your ad platform.",
        placement: "top",
        title: "Location Targeting"
    },
    {
        target: "[data-tour='language-targeting']",
        content: "Target listeners by language. Useful if your music is tied to a specific language community.",
        placement: "top",
        title: "Language Targeting"
    },
    {
        target: "[data-tour='interest-targeting']",
        content: "Add interest categories that match your audience. Keep it tight — the more specific your interests, the more relevant the people who see your ad.",
        placement: "top",
        title: "Interest Targeting"
    },
    {
        target: "[data-tour='ad-creative']",
        content: "Build your ad. Upload a visual, pick your call-to-action, and write the copy that appears when people see your ad.",
        placement: "top",
        title: "Ad Creative"
    },
    {
        target: "[data-tour='choose-image']",
        content: "Pick the image for your ad. Pull from your connected social accounts or upload directly from your device. Max 5 images.",
        placement: "top",
        title: "Choose Image"
    },
    {
        target: "[data-tour='call-to-actions']",
        content: "Choose the button that appears on your ad — like 'Listen Now' or 'Learn More.' This is what people tap to visit your link.",
        placement: "top",
        title: "Call-to-Action"
    },
    {
        target: "[data-tour='ad-details']",
        content: "Write your ad copy. Add a headline to grab attention, a description to give context, and the link you want to send people to.",
        placement: "top",
        title: "Ad Details"
    },
    {
        target: "[data-tour='review-launch']",
        content: "Final check before your campaign goes live. Review all your settings and see exactly how your ad will appear.",
        placement: "top",
        title: "Review & Launch"
    },
    {
        target: "[data-tour='preview-ad']",
        content: "See a live preview of your ad across formats. Toggle between placements to make sure it looks right before you launch.",
        placement: "top",
        title: "Ad Preview"
    },
    {
        target: "[data-tour='check-details']",
        content: "Details - Confirm your selections before payment..",
        placement: "top",
        title: "Campaign Details"
    },
    {
        target: "[data-tour='summary']",
        content: "Your campaign at a glance. Confirm your objective, platform, budget, and call-to-action, then launch.",
        placement: "top",
        title: "Campaign Summary"
    },
];

export const campaignEditorTourSteps = [
    { target: "[data-tour='campaign-header']", title: 'Campaign Overview', content: "See your campaign's current status at a glance — the objective it's running, which artist profile it's tied to, and whether it's live, paused, or finished.", placement: 'bottom' },
    { target: "[data-tour='campaign-actions']", title: 'Campaign Actions (Duplicate, Rename, Pause, Edit Budget, Edit End Date)', content: "Manage your campaign directly from here. Duplicate it to reuse the setup, rename it, pause it, adjust your budget, or extend the end date — without starting over.", placement: 'bottom' },
    { target: "[data-tour='campaign-banner']", title: 'Campaign Status Banner', content: "This banner updates based on your campaign state — whether it's still running, finished, or needs your attention. Check here for any follow-up actions.", placement: 'bottom' },
    { target: "[data-tour='amplitude-ai-chat']", title: 'Amplitude AI Chat', content: "Ask Amplitude anything about this campaign — what's working, what to improve, and how to get more out of your current spend. It has full context on your results.", placement: 'bottom' },
    { target: "[data-tour='campaign-budget']", title: 'Budget & Spend', content: "Track how much you've spent against your total budget and see your campaign's run dates. A quick check on where your money is going.", placement: 'top' },
    { target: "[data-tour='campaign-length']", title: 'Campaign Length', content: "See the exact start and end dates your campaign is set to run. Use this to plan the timing and duration of future campaigns.", placement: 'top' },
    { target: "[data-tour='performance-overview']", title: 'Performance Overview', content: "Your top-level campaign stats — ad clicks, cost-per-click, link clicks, and cost-per-conversion. These are the numbers that tell you if your ad is doing its job.", placement: 'left' },
    { target: "[data-tour='performance-stats-tiles']", title: 'Performance Stat Tiles', content: "Performance Stat Tiles A full breakdown of your campaign activity — total spend, reach, impressions, CPM, likes, shares, comments, and ad link clicks. Use these to understand how your ad is landing with people.", placement: 'top' },
    { target: "[data-tour='primary-secondary-markets']", title: 'Primary & Secondary Markets', content: 'See how your budget is split across markets. Adjust the percentage allocated to each market as needed — just make sure your primary and secondary splits add up to 100%.', placement: 'top' },
    { target: "[data-tour='streaming-clicks']", title: 'Streaming Clicks by Platform', content: "These are the clicks that make it all the way through to your streaming platform. They'll always be lower than total ad clicks — but these are the ones that count the most.", placement: 'top' },
    { target: "[data-tour='top-demographics-clicks']", title: 'Top Demographics by Clicks', content: "See which age groups and genders are clicking your ad the most. Use this to refine your targeting and get more out of your budget.", placement: 'top' },
    { target: "[data-tour='top-country-clicks']", title: 'Top Country by Clicks', content: "See which countries are driving the most clicks on your ad. If a market is overperforming, it's worth targeting it more directly.", placement: 'top' },
    { target: "[data-tour='creative-performance']", title: 'Creative Performance', content: "See how your individual creatives are performing across Reels, Stories, and Posts. Upload new assets here to refresh a running campaign without rebuilding it from scratch.", placement: 'left' },
    { target: "[data-tour='creative-preview']", title: 'Creative Preview', content: "A preview of the creative currently running in your campaign. This is what people see when your ad shows up in their feed.", placement: 'left' },
    { target: "[data-tour='setup-details']", title: 'Setup Details', content: "A full record of how this campaign is configured — the promoted link, connected ad account, connected platform page and profile, and conversion settings.", placement: 'left' },
];

export const professorUToursteps = [
    {
        target: "[data-tour='distinctions']",
        content: "Track your progress across every module. Distinctions are earned by completing key actions — they show how deep you've gone into each part of the platform.",
        placement: "bottom",
        title: "Distinctions"
    },
    {
        target: "[data-tour='app-tour-lessons']",
        content: "Every module on UpNComer has a lesson here. Click in to get a guided walkthrough of what each tool does and how to use it.",
        placement: "top",
        title: "Lessons with ProfessorU"
    },
    {
        target: "[data-tour='module-guides']",
        content: "Pick any module and get a focused guide for it. Covers every tool across Growth Engine, Publicist, UrStudio, Artist Manager, Data Analyst, Amplitude AI, and more.",
        placement: "top",
        title: "Guide by Modules"
    },
    {
        target: "[data-tour='interviews-talks']",
        content: "Real conversations with artists and industry people — career moves, marketing, creative process, and how the industry actually works. Watch when you want perspective beyond the tools.",
        placement: "top",
        title: "Artist Interviews & Industry Talks"
    },
    // {
    //   target: "[data-tour='module-walkthroughs']",
    //   content: "The Module Walkthroughs section provides comprehensive walkthroughs for each of our modules. Whether you're new to a module or looking to deepen your understanding, these walkthroughs will guide you through the features, functionalities, and best practices for using each module effectively. From setting up your first campaign in Growth Engine to mastering your tracks in UrStudio, these walkthroughs are your go-to resource for mastering our platform.",
    //   placement: "top",
    //   title: "Module Walkthroughs"
    // },
];

export const lessonPageTourSteps = [
    {
        target: "[data-tour='lesson-viewer']",
        content: "This is where all your learning content lives — articles, walkthrough videos, and documents for every module on the platform.",
        placement: "top",
        title: "Guide Viewer"
    },
    {
        target: "[data-tour='module-walkthroughs']",
        content: "Step-by-step guides for each module. Pick the one you want to get deeper on and learn how to use every feature properly.",
        placement: "top",
        title: "Module Walkthroughs"
    },
    {
        target: "[data-tour='lessons']",
        content: "Module-specific lessons that walk you through features in detail. A good starting point if you're new to a section of the platform.",
        placement: "top",
        title: "Lessons with ProfessorU"
    },
    {
        target: "[data-tour='industry-talks']",
        content: "Interviews with artists and industry people. Real perspectives on how the music industry works — useful context beyond the tools.",
        placement: "top",
        title: "Industry Talks"
    },
    {
        target: "[data-tour='module-navigation']",
        content: "Use the arrows to browse between modules. Each one has its own set of guides, lessons, and talks.",
        placement: "top",
        title: "Module Navigation"
    },
];

export const resourceLibraryTourSteps = [
    {
        target: "[data-tour='walkthrough-guides']",
        content: "Step-by-step guides for the most common tasks on the platform — from setting up your ads account to uploading tracks and understanding your data.",
        placement: "top",
        title: "Walkthrough Guides"
    },
    {
        target: "[data-tour='troubleshooting-guides']",
        content: "Running into an issue? Find fixes and guidance here for common problems across every module.",
        placement: "top",
        title: "Troubleshooting Guides"
    },
    {
        target: "[data-tour='post-questions']",
        content: "Got a question that's not covered in the guides? Post it here and get answers from the UpNComer community.",
        placement: "top",
        title: "Post Questions"
    },
    {
        target: "[data-tour='your-questions']",
        content: "All the questions you've posted in the forum live here. Check back to see replies and follow the discussion.",
        placement: "top",
        title: "Your Questions"
    },
    {
        target: "[data-tour='featured-questions']",
        content: "The most useful questions from across the community — popular topics, expert answers, and discussions worth reading even if you didn't ask.",
        placement: "top",
        title: "Featured Questions"
    },
];

export const rewardsTourStep = [
    {
        target: "[data-tour='rewards-list']",
        content: "Every module has its own set of rewards. They unlock in sequence — complete the target for one to unlock the next. Track your progress across Growth Engine, Publicist, Artist Manager, and more.",
        placement: "top",
        title: "Rewards List"
    },
];

export const contentViewerTourSteps = [
    {
        target: "[data-tour='content-viewer']",
        content: "Watch interviews and talks with artists and industry professionals directly here. Click any video to start.",
        placement: "top",
        title: "Content Viewer"
    },
    {
        target: "[data-tour='content-navigation']",
        content: "Use the arrows to browse interviews across different modules and topics.",
        placement: "top",
        title: "Content Navigation"
    },
];

export const accountSetupTourSteps = [
    {
        target: `[data-tour='account-setup-1']`,
        content: `Welcome to UpNComer Distribution. This is where you’ll manage releases, collect royalties, pitch to playlists, and distribute your music to hundreds of platforms worldwide. If you don’t yet have access, submit an invite request and our team will review your application.`,
        placement: 'top',
        title: `Distribution Access`
    },
    {
        target: `[data-tour='account-setup-2']`,
        content: `Before uploading music, take a few minutes to configure your distribution account. Proper setup ensures your releases are delivered correctly and your royalties reach you without delays.`,
        placement: 'top',
        title: `Distribution Portal Account Settings`
    },
    {
        target: `[data-tour='account-setup-3']`,
        content: `Review your general account settings, including password and security options. Keeping your account secure helps protect your catalog, earnings, and release data.`,
        placement: 'top',
        title: `General Account Settings`
    },
    {
        target: `[data-tour='account-setup-4']`,
        content: `Make sure your account information is accurate and up to date. Your name, display name, and address may be used during account verification and royalty processing.`,
        placement: 'top',
        title: `Account Details`
    },
    {
        target: `[data-tour='account-setup-5']`,
        content: `Connect your preferred payout method so royalties can be paid directly to you. We recommend setting this up before uploading your first release to avoid delays when earnings become available.`,
        placement: 'top',
        title: `Payout Preferences`
    },
    {
        target: `[data-tour='account-setup-6']`,
        content: `Enter your artist name, primary genre, and language. These details help platforms categorize your music correctly and improve release accuracy.`,
        placement: 'top',
        title: `Artist Details`
    },
    {
        target: `[data-tour='account-setup-7']`,
        content: `If you already have artist profiles on Spotify or Apple Music, connect them here. This helps ensure future releases are delivered to the correct artist pages instead of creating duplicate profiles.`,
        placement: 'top',
        title: `Connect Existing Spotify & Apple Music Profiles`
    },
    {
        target: `[data-tour='account-setup-8']`,
        content: `Add existing artist profiles for platforms such as Amazon Music, Meta, and SoundCloud. If you don’t yet have a profile on a platform, simply select “No” and a profile will be created when your music is delivered.`,
        placement: 'top',
        title: `Connect Additional Platform Profiles`
    },
    {
        target: `[data-tour='account-setup-9']`,
        content: `Configure default artist credits and platform connections that will automatically populate whenever you create a new release. This saves time and reduces manual entry.`,
        placement: 'top',
        title: `Uploader Defaults`
    },
    {
        target: `[data-tour='account-setup-10']`,
        content: `Configure your preferred genres, language, record label information, and copyright details. These settings can be changed per release later, but setting defaults now will speed up future uploads.`,
        placement: 'top',
        title: `Release Information Defaults`
    },
    {
        target: `[data-tour='account-setup-11']`,
        content: `Enable any additional services you want applied by default, including YouTube Content ID, Meta Rights Manager, SoundCloud Monetization, LyricFind, SoundExchange, and other optional delivery services.`,
        placement: 'top',
        title: `Distribution Preferences`
    },
    {
        target: `[data-tour='account-setup-12']`,
        content: `Connect your website, YouTube channel, SoundCloud profile, and other platform links. Providing this information helps streamline artist verification and release review.`,
        placement: 'top',
        title: `Platforms & Website Links`
    },
    {
        target: `[data-tour='account-setup-13']`,
        content: `Connect your Facebook, Instagram, X (Twitter), and YouTube profiles. Consistent social links help establish your artist identity across platforms and support profile verification.`,
        placement: 'top',
        title: `Social Media Profiles`
    },
    {
        target: `[data-tour='account-setup-14']`,
        content: `Add industry profile links such as Wikipedia, MusicBrainz, AllMusic, and ISNI if available. You can also save frequent collaborators here to make future release uploads faster and ensure contributor information remains consistent.`,
        placement: 'top',
        title: `Industry Profiles & Collaborators`
    },
    {
        target: `[data-tour='account-setup-15']`,
        content: `Once you’ve completed your profile, payout settings, platform connections, uploader defaults, and collaborator information, click Save Changes to finalize your Distribution account setup.
Your distribution account is now configured and ready for your first release.
`,
        placement: 'top',
        title: `Save Changes`
    },
]

export const musicReleaseTourSteps = [
    {
        target: `[data-tour='release-1']`,
        content: `Navigate to Distribution and click Create Release. Select whether you’re uploading a Single, EP, or Album and begin creating your release.`,
        placement: 'top',
        title: `Create A New Release`
    },
    {
        target: `[data-tour='release-2']`,
        content: `Enter the release title and complete the required release-level information before proceeding.`,
        placement: 'top',
        title: `Complete Basic Information`
    },
    {
        target: `[data-tour='release-3']`,
        content: `Upload your release artwork. We recommend high-quality square artwork that accurately represents your release and complies with platform artwork guidelines.`,
        placement: 'top',
        title: `Upload Artwork`
    },
    {
        target: `[data-tour='release-4']`,
        content: `Choose the date your release should become available on streaming platforms. We recommend uploading at least 2–4 weeks before release day to allow time for delivery and playlist pitching.`,
        placement: 'top',
        title: `Set Your Release Date`
    },
    {
        target: `[data-tour='release-5']`,
        content: `Choose the genre that best represents your release. Accurate genre selection helps platforms categorize and recommend your music correctly.`,
        placement: 'top',
        title: `Select Your Genre`
    },
    {
        target: `[data-tour='release-6']`,
        content: `Choose the primary language used throughout the release. If your release contains no vocals, enable the No Lyrics / Instrumental option.`,
        placement: 'top',
        title: `Select Release Language`
    },
    {
        target: `[data-tour='release-7']`,
        content: `Enter the record label associated with the release. Independent artists commonly use their artist name, company name, or personal label name..`,
        placement: 'top',
        title: `Add Label Information`
    },
    {
        target: `[data-tour='release-8']`,
        content: `Enter the copyright owner information for both the sound recording (℗) and publishing rights (©). This is typically your name, publisher, company name, or record label.`,
        placement: 'top',
        title: `Configure Copyright Information`
    },
    {
        target: `[data-tour='release-9']`,
        content: `Choose which stores and streaming services should receive your release. By default, your release can be delivered to hundreds of supported platforms worldwide.`,
        placement: 'top',
        title: `Select Distribution Platforms`
    },
    {
        target: `[data-tour='release-10']`,
        content: `Enable optional services such as YouTube Content ID, Meta Rights Manager, SoundCloud Monetization, SoundExchange, LyricFind, Beatport, Tracklib, Hook, EVEN, and any other available delivery options relevant to your release.`,
        placement: 'top',
        title: `Configure Additional Delivery Services`
    },
    {
        target: `[data-tour='release-11']`,
        content: `Add optional metadata including version information, licensing type, iTunes pricing, UPC codes, territory restrictions, and any other optional release settings required for distribution.`,
        placement: 'top',
        title: `Configure Optional Release Settings`
    },
    {
        target: `[data-tour='release-12']`,
        content: `Review all release information and click Save Changes before moving on to track management.`,
        placement: 'top',
        title: `Save Release Information`
    },
    {
        target: `[data-tour='release-13']`,
        content: `Open the Manage Tracks section to begin uploading and configuring the songs included in your release.`,
        placement: 'top',
        title: `Navigate To Manage Tracks`
    },
    {
        target: `[data-tour='release-14']`,
        content: `Click Upload Tracks and upload your master audio files. WAV files are recommended to ensure the highest delivery quality.`,
        placement: 'top',
        title: `Upload Audio Files`
    },
    {
        target: `[data-tour='release-15']`,
        content: `After upload, select Edit Track Information for each song to configure metadata, credits, audio versions, and lyrics.`,
        placement: 'top',
        title: `Edit Track Information`
    },
    {
        target: `[data-tour='release-16']`,
        content: `Enter the song title exactly as it should appear on streaming platforms. Avoid adding artist names, dates, emojis, or version information within the title field.`,
        placement: 'top',
        title: `Configure Track Title`
    },
    {
        target: `[data-tour='release-17']`,
        content: `Select the track language and indicate whether the song contains lyrics, explicit content, clean versions, or instrumental audio.`,
        placement: 'top',
        title: `Configure Track Language`
    },
    {
        target: `[data-tour='release-18']`,
        content: `Assign or generate ISRC and ISWC codes where applicable. These identifiers help track ownership, royalty collection, and usage reporting.`,
        placement: 'top',
        title: `Configure ISRC & ISWC Information`
    },
    {
        target: `[data-tour='release-19']`,
        content: `Select the portion of the song that should be highlighted when users create content with your music on TikTok.`,
        placement: 'top',
        title: `Configure TikTok Start Time`
    },
    {
        target: `[data-tour='release-20']`,
        content: `Under Participants → Artist Roles, add all primary artists, featured artists, remixers, and collaborators associated with the track.`,
        placement: 'top',
        title: `Add Artist Credits`
    },
    {
        target: `[data-tour='release-21']`,
        content: `If artists already have Spotify, Apple Music, or other platform profiles, connect them to ensure releases are delivered to the correct artist pages.`,
        placement: 'top',
        title: `Connect Existing Artist Profiles`
    },
    {
        target: `[data-tour='release-22']`,
        content: `Under Participants → Writer Roles, add all composers, lyricists, songwriters, and publishing contributors associated with the track.`,
        placement: 'top',
        title: `Add Songwriter Credits`
    },
    {
        target: `[data-tour='release-23']`,
        content: `Under Participants → Additional Credits, add producers, engineers, musicians, mastering engineers, mixers, and any other contributors who should receive credit.`,
        placement: 'top',
        title: `Add Additional Contributor Credits`
    },
    {
        target: `[data-tour='release-24']`,
        content: `Under the Audio tab, review the uploaded master file and verify playback before submission.`,
        placement: 'top',
        title: `Review Audio Options`
    },
    {
        target: `[data-tour='release-25']`,
        content: `If available, upload an instrumental version of the track for future licensing and delivery opportunities.`,
        placement: 'top',
        title: `Upload Instrumental Versions`
    },
    {
        target: `[data-tour='release-26']`,
        content: `If your song has been mixed in Dolby Atmos, upload the Atmos master version for supported platforms.`,
        placement: 'top',
        title: `Upload Dolby Atmos Versions`
    },
    {
        target: `[data-tour='release-27']`,
        content: `If your release has been certified as an Apple Digital Master, enter the required mastering information and upload the approved ADM version.`,
        placement: 'top',
        title: `Upload Apple Digital Masters`
    },
    {
        target: `[data-tour='release-28']`,
        content: `Navigate to the Lyrics tab and paste your song lyrics. If lyrics contain explicit content, enable the Explicit Lyrics option.`,
        placement: 'top',
        title: `Add Lyrics`
    },
    {
        target: `[data-tour='release-29']`,
        content: `Click Save Changes to finalize all metadata, contributor information, audio versions, and lyrics for the track.`,
        placement: 'top',
        title: `Save Track Changes`
    },
    {
        target: `[data-tour='release-30']`,
        content: `Repeat the track configuration process for every song included in your release.`,
        placement: 'top',
        title: `Repeat For All Tracks`
    },
    {
        target: `[data-tour='release-31']`,
        content: `Review your tracklist and drag tracks into the correct order if necessary. This order will determine how the release appears on streaming platforms.`,
        placement: 'top',
        title: `Arrange Track Order`
    },
    {
        target: `[data-tour='release-32']`,
        content: `Check the release validation panel and resolve any missing metadata, artwork, contributor information, or delivery issues before submission.`,
        placement: 'top',
        title: `Review Release Issues`
    },
    {
        target: `[data-tour='release-33']`,
        content: `Open the Preview Release section and carefully review all release information, artwork, track metadata, credits, lyrics, and audio files.`,
        placement: 'top',
        title: `Preview Your Release`
    },
    {
        target: `[data-tour='release-34']`,
        content: `Click Save Changes one final time to ensure all release information is stored correctly.`,
        placement: 'top',
        title: `Save Final Changes`
    },
    {
        target: `[data-tour='release-35']`,
        content: `Once everything has been reviewed and verified, click Publish to submit your release for processing and delivery.
Your release will now enter the distribution queue and begin delivery to your selected streaming platforms worldwide.
`,
        placement: 'top',
        title: `Publish Your Release`
    }
]